
            const data = {"name":"icon-edit","data":{"width":"14","height":"14","viewBox":"0 0 14 14","data":"<path pid=\"0\" d=\"M7.299 2.918L1.739 8.51l3.72 3.741 5.56-5.593zm-2.837 9.994L1.079 9.509.022 13.272a.576.576 0 00.14.565.573.573 0 00.56.142l3.74-1.067zm9.287-9.824L10.849.17a.578.578 0 00-.82 0L8.12 2.092l3.719 3.742 1.911-1.922a.586.586 0 000-.824\" _fill=\"currentColor\" fill-rule=\"evenodd\"/>"}}
        
                module.exports = data
                